export default __webpack_public_path__ + "static/media/Group54.ebc1ddd7.png";